function createKey() {
    return Math.random().toString(36).slice(2, 10);
}
function readSessionStorage(key) {
    try {
        return JSON.parse(window.sessionStorage.getItem(key) || '');
    }
    catch (e) { }
}
function saveToSessionStorage(history, key) {
    try {
        window.sessionStorage.setItem(key, JSON.stringify({ history }));
    }
    catch (e) { }
}
function makeServerSideHistory(push, replace) {
    return {
        untrack: () => { },
        push,
        replace,
        transition: push,
        backOrPush: push,
        backOrReplace: replace,
        previousPageOrPush: push,
        previousPageOrReplace: replace,
        canGoBack: () => false,
    };
}
export function track(prefix, push, replace) {
    var _a, _b;
    if (typeof window == 'undefined')
        return makeServerSideHistory(push, replace);
    const key = `${prefix}-history`;
    const locationKey = (_a = window.history.state) === null || _a === void 0 ? void 0 : _a.locationKey;
    const sessionData = readSessionStorage(key);
    const history = (_b = sessionData === null || sessionData === void 0 ? void 0 : sessionData.history) !== null && _b !== void 0 ? _b : [];
    let index = history.findIndex((h) => h.locationKey === locationKey);
    // save original push/replace state
    const pushState = window.history.pushState;
    const replaceState = window.history.replaceState;
    // patch window push/replace state
    window.history.pushState = function (data, unused, url) {
        var _a, _b;
        const locationKey = createKey();
        const entryLocationKey = (_a = data === null || data === void 0 ? void 0 : data.options) === null || _a === void 0 ? void 0 : _a.entryLocationKey;
        const fallback = (_b = data === null || data === void 0 ? void 0 : data.options) === null || _b === void 0 ? void 0 : _b.fallback;
        const state = {
            locationKey,
            locationUrl: data === null || data === void 0 ? void 0 : data.as,
            entryLocationKey,
            fallback,
        };
        // push history state to correct position
        if (index == history.length - 1) {
            history.push(state);
        }
        else {
            history.splice(index + 1, Infinity, state);
        }
        // we are now at the top of the history stack
        index = history.length - 1;
        // call original pushState
        pushState.call(window.history, Object.assign(Object.assign({}, data), { locationKey }), unused, url);
    };
    window.history.replaceState = function (data, unused, url) {
        var _a, _b;
        const current = history[index];
        const fallback = (_a = data === null || data === void 0 ? void 0 : data.options) === null || _a === void 0 ? void 0 : _a.fallback;
        if ((data === null || data === void 0 ? void 0 : data.as) != ((_b = window.history.state) === null || _b === void 0 ? void 0 : _b.as) || !current) {
            // when location changed, we must pop all upper history state
            const locationKey = createKey();
            history.splice(index, Infinity, {
                locationKey,
                locationUrl: data === null || data === void 0 ? void 0 : data.as,
                fallback,
            });
            index = history.length - 1;
            replaceState.call(window.history, Object.assign(Object.assign({}, data), { locationKey }), unused, url);
        }
        else {
            // but when location not changed, we could just update the history state data
            replaceState.call(window.history, Object.assign(Object.assign({}, data), { locationKey: current.locationKey }), unused, url);
        }
    };
    function handlePageHide() {
        saveToSessionStorage(history, key);
    }
    function handlePopState(e) {
        index = history.findIndex((h) => { var _a; return h.locationKey === ((_a = e.state) === null || _a === void 0 ? void 0 : _a.locationKey); });
    }
    window.addEventListener('pagehide', handlePageHide);
    window.addEventListener('popstate', handlePopState);
    function untrack() {
        window.removeEventListener('popstate', handlePopState);
        window.removeEventListener('pagehide', handlePageHide);
        // restore original push/replace state
        window.history.pushState = pushState;
        window.history.replaceState = replaceState;
    }
    function canGoBackFrom(index) {
        var _a;
        // we can go back if we are not at the bottom of the stack, and the current
        // state is not the result of a fallback naviation
        return index > 0 && !((_a = history[index]) === null || _a === void 0 ? void 0 : _a.fallback);
    }
    function canGoBack() {
        return canGoBackFrom(index);
    }
    function back(fallback) {
        return (url, as, options) => {
            if (canGoBackFrom(index))
                return window.history.back();
            else
                return fallback(url, as, Object.assign(Object.assign({}, options), { fallback: true }));
        };
    }
    const backOrPush = back(push);
    const backOrReplace = back(replace);
    function findEntryLocationIndex() {
        var _a;
        const entryLocationKey = (_a = history[index]) === null || _a === void 0 ? void 0 : _a.entryLocationKey;
        // entry page state will not have entryLocationKey
        if (!entryLocationKey)
            return index;
        // find backward
        for (let i = index; i >= 0; i--) {
            if (
            // found entry location
            entryLocationKey === history[i].locationKey ||
                // found state is the result of a fallback naviation
                history[i].fallback)
                return i;
        }
        return -1;
    }
    function previousPage(fallback) {
        return function (url, as, options) {
            const entryIndex = findEntryLocationIndex();
            if (entryIndex > -1 && canGoBackFrom(entryIndex)) {
                // found entry and can go back
                // then we can go to previous page
                return window.history.go(entryIndex - index - 1);
            }
            // we can't go to previous page, fallback
            return fallback(url, as, Object.assign(Object.assign({}, options), { fallback: true }));
        };
    }
    const previousPageOrPush = previousPage(push);
    const previousPageOrReplace = previousPage(replace);
    const transition = function (url, as, options) {
        var _a, _b, _c;
        const entryLocationKey = (_b = (_a = history[index]) === null || _a === void 0 ? void 0 : _a.entryLocationKey) !== null && _b !== void 0 ? _b : (_c = window.history.state) === null || _c === void 0 ? void 0 : _c.locationKey;
        return push(url, as, Object.assign(Object.assign({}, options), { entryLocationKey }));
    };
    return {
        untrack,
        push,
        replace,
        transition,
        backOrPush,
        backOrReplace,
        previousPageOrPush,
        previousPageOrReplace,
        canGoBack,
    };
}
